module.exports = __webpack_public_path__ + "media/images/bed-count-6a55769bd11ed7a415896b824f7c4f14.svg";